var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './style.scss';
import greyBackgroundCta from '../../assets/images/announcementBar/grey-background-cta-arrow.png';
import yellowBackgroundCta from '../../assets/images/announcementBar/yellow-background-cta-arrow.png';
import graphicBackgroundCta from '../../assets/images/announcementBar/graphic-background-cta-arrow.png';
import greyBackgroundCloseButton from '../../assets/images/announcementBar/grey-background-close-icon.png';
import yellowBackgroundCloseButton from '../../assets/images/announcementBar/yellow-background-close-icon.png';
import graphicBackgroundCloseButton from '../../assets/images/announcementBar/graphic-background-close-icon.png';
var data = {
    backgroundSolidColor: '#ffffff',
};
var defaultProps = {
    data: data,
};
var AnnouncementBar = function (_a) {
    var _b = _a.data, headline = _b.headline, background_type = _b.background_type, cta_copy = _b.cta_copy, cta_link = _b.cta_link, background_color = _b.background_color, background_media_large = _b.background_media_large, background_media_medium = _b.background_media_medium, background_media_small = _b.background_media_small;
    var _c = useState(window.innerWidth), width = _c[0], setWidth = _c[1];
    var _d = useState(document.querySelector('.layout-container')), layoutContainer = _d[0], setLayoutContainer = _d[1];
    var _e = useState(document.querySelector('.announcement-bar-main-container')), announcementBarContainer = _e[0], setAnnouncementBarContainer = _e[1];
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(function () {
        window.addEventListener('resize', handleWindowSizeChange);
        return function () {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    var isMobile = width < 768;
    var isTablet = width >= 768 && width < 1024;
    var _f = useState(true), showBar = _f[0], setShowBar = _f[1];
    useEffect(function () {
        var isAnnouncementBarClosed = localStorage.getItem('announcementBarClosed');
        if (isAnnouncementBarClosed) {
            setShowBar(false);
        }
    }, []);
    useEffect(function () {
        setLayoutContainer(document.querySelector('.layout-container'));
        setAnnouncementBarContainer(document === null || document === void 0 ? void 0 : document.querySelector('.announcement-bar-main-container'));
        if (layoutContainer && announcementBarContainer && showBar) {
            layoutContainer === null || layoutContainer === void 0 ? void 0 : layoutContainer.classList.add('announcement-bar-present');
        }
        else {
            announcementBarContainer === null || announcementBarContainer === void 0 ? void 0 : announcementBarContainer.classList.remove('announcement-bar-present');
        }
    }, [showBar, announcementBarContainer]);
    var handleClick = function () {
        localStorage.setItem('announcementBarClosed', 'true');
        setShowBar(false);
        layoutContainer === null || layoutContainer === void 0 ? void 0 : layoutContainer.classList.remove('announcement-bar-present');
    };
    return (_jsx(_Fragment, { children: showBar && (_jsxs("div", __assign({ style: {
                backgroundImage: background_type == 'image' && isMobile
                    ? "url(" + background_media_small + ")"
                    : background_type == 'image' && isTablet
                        ? "url(" + background_media_medium + ") "
                        : "url(" + background_media_large + ")",
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }, className: "announcement-bar-main-container " + (background_type == 'color' && background_color == '#343741'
                ? 'grey-bg'
                : background_type == 'color' && background_color == '#FDB515'
                    ? 'yellow-bg'
                    : 'graphic-bg') + " " }, { children: [_jsxs("div", __assign({ className: "announcement-bar-content" }, { children: [headline && (_jsx("div", __assign({ className: "announcement-bar-main-text " + (background_type == 'color' && background_color == '#343741'
                                ? 'grey-bg'
                                : background_type == 'color' &&
                                    background_color == '#FDB515'
                                    ? 'yellow-bg'
                                    : 'graphic-bg') }, { children: headline }), void 0)),
                        cta_copy && cta_link && (_jsxs("div", __assign({ className: "announcement-bar-cta" }, { children: [_jsx("div", __assign({ className: "announcement-bar-cta-text " + (background_type == 'color' && background_color == '#343741'
                                        ? 'grey-bg'
                                        : background_type == 'color' &&
                                            background_color == '#FDB515'
                                            ? 'yellow-bg'
                                            : 'graphic-bg') }, { children: _jsx("a", __assign({ href: cta_link }, { children: cta_copy }), void 0) }), void 0),
                                _jsxs("div", __assign({ className: "announcement-bar-cta-arrow" }, { children: [background_type == 'color' &&
                                            background_color == '#343741' && (_jsx("img", { src: greyBackgroundCta, alt: "announcement bar cta" }, void 0)),
                                        background_type == 'color' &&
                                            background_color == '#FDB515' && (_jsx("img", { src: yellowBackgroundCta, alt: "announcement bar cta" }, void 0)),
                                        background_type == 'image' && (_jsx("img", { src: graphicBackgroundCta, alt: "announcement bar cta" }, void 0))] }), void 0)] }), void 0))] }), void 0),
                _jsxs("div", __assign({ className: "announcement-bar-close-button", onClick: handleClick }, { children: [background_type == 'color' && background_color == '#343741' && (_jsx("img", { src: greyBackgroundCloseButton, alt: "announcement bar close button" }, void 0)),
                        background_type == 'color' && background_color == '#FDB515' && (_jsx("img", { src: yellowBackgroundCloseButton, alt: "announcement bar close button" }, void 0)),
                        background_type == 'image' && (_jsx("img", { src: graphicBackgroundCloseButton, alt: "announcement bar close button" }, void 0))] }), void 0)] }), void 0)) }, void 0));
};
export default AnnouncementBar;
AnnouncementBar.defaultProps = defaultProps;
